import { NotificationService } from '@cradua/core';
import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { map, catchError, concatMap, exhaustMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as CountryActions from './country.actions';
import { CountryService } from '../../services/country.service';

@Injectable()
export class CountryEffects {
  loadCountry$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CountryActions.loadCountry),
      exhaustMap((_) =>
        this.countryService.getCountry().pipe(
          map((data) => CountryActions.loadCountrySuccess({ country: data })),
          catchError((error) =>
            of(CountryActions.loadCountryFailure({ error }))
          )
        )
      )
    )
  );

  addCountry$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CountryActions.addCountry),
      concatMap(({ newCountry }) =>
        this.countryService.createCountry(newCountry).pipe(
          map((data) => {
            this.notification.success('Saved Successfully');
            return CountryActions.addCountrySuccess({ newCountry: data });
          }),
          catchError((error) =>
            of(CountryActions.addCountryFailure({ error: error.error.message }))
          )
        )
      )
    )
  );

  updateCountry$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CountryActions.updateCountry),
      map((action) => action.updateCountry),
      concatMap((updateCountry) =>
        this.countryService.updateCountry(updateCountry).pipe(
          map((_) => {
            this.notification.success('Updated Successfully');
            return CountryActions.updateCountrySuccess({
              updateCountry: updateCountry,
            });
          }),
          catchError((error) =>
            of(CountryActions.updateCountryFailure({ error: error.message }))
          )
        )
      )
    )
  );

  removeCountry$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CountryActions.removeCountry),
      map((action) => action.ids),
      concatMap((ids) =>
        this.countryService.deleteCountry(ids).pipe(
          map(() => {
            this.notification.success('Deleted Successfully');
            return CountryActions.removeCountrySuccess({ ids });
          }),
          catchError((error) =>
            of(CountryActions.updateCountryFailure({ error: error.message }))
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private countryService: CountryService,
    private notification: NotificationService
  ) {}
}
